import Const from 'constants';
import {TeamDetailsComponent as LOLTeamDetailsComponent} from './sports/lol';
import {TeamDetailsComponent as MLBTeamDetailsComponent} from './sports/mlb';
import {TeamDetailsComponent as NHLTeamDetailsComponent} from './sports/nhl';
import {TeamDetailsComponent as CFBTeamDetailsComponent} from './sports/cfb';
import {TeamDetailsComponent as NFLTeamDetailsComponent} from './sports/nfl';
import {TeamDetailsComponent} from './index';

const Factory = {
    getComponent(sportConfig) {
        if (sportConfig.isSportMlb()) {
            return MLBTeamDetailsComponent;
        }

        if (sportConfig.isSportNhl()) {
            return NHLTeamDetailsComponent;
        }

        if (sportConfig.isSportLol()) {
            return LOLTeamDetailsComponent;
        }

        if (sportConfig.isSportCfb()) {
            return CFBTeamDetailsComponent;
        }

        if (sportConfig.isSportNfl()) {
            return NFLTeamDetailsComponent;
        }

        return TeamDetailsComponent;
    },
};

export {Factory};
